import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { useMealCreditFormData } from 'src/components/oneCorp/features/MealCredit/components/Form/MealCreditDataProvider/MealCreditDataProvider';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getDurationsAvailabilityInfo } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/DurationsRule/getDurationsAvailabilityInfo';

export interface UseGetDurationsAvailabilityInfo {
  availabilityInfo: string;
}

export const useGetDurationsAvailabilityInfo =
  (): UseGetDurationsAvailabilityInfo => {
    const { errors } = useFormContext<IMealCreditFormFields>();
    const { formValues } = useMealCreditFormData();
    const {
      selectedDays,
      budgetResetPeriod,
      isDailyLengthBudget,
      isWeeklyLengthBudget,
      isMonthlyLengthBudget,
      isMonthAvailable,
      budgetLength,
      budgetResetType,
      isRepeating,
      startDate,
      expirationDate,
      endTimeFullDate,
      expiresOn,
      timeIntervalType,
      numberOfConsecutiveDays,
      numberOfConsecutiveMonths,
      monthAvailableOn,
      monthAvailableTo,
    } = formValues;

    const availabilityInfo = getDurationsAvailabilityInfo({
      isDailyLengthBudget,
      isWeeklyLengthBudget,
      isMonthlyLengthBudget,
      isMonthAvailable,
      budgetLength,
      isRepeating,
      startDate,
      endTimeFullDate,
      selectedDays,
      budgetResetType,
      budgetResetPeriod: Number(budgetResetPeriod),
      expirationDate,
      expiresOn,
      timeIntervalType,
      errors,
      refreshPeriodDaysCount: numberOfConsecutiveDays,
      refreshPeriodMonthsCount: numberOfConsecutiveMonths,
      monthAvailableOn,
      monthAvailableTo,
    });

    return {
      availabilityInfo,
    };
  };
